module.exports = __webpack_public_path__ + "static/mary-kay-background-77b469dfe635c0dcc2cc564adfefea39.png";